import { Grid, TextField } from '@mui/material';
import { IOtherAsset } from '../../../../../../Interfaces/Asset/IOtherAsset';
import { ITestamentAssetsViewProps } from '../../../../../../Interfaces/Asset/ITestamentAssetsViewProps';

type OtherAssetViewProps = ITestamentAssetsViewProps<IOtherAsset>;

export function OtherAssetView({ asset, setAsset }: OtherAssetViewProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label='Beschreibung des Vermögensgegenstandes'
          minRows={3}
          size='small'
          multiline
          value={asset.data.notes || ''}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                notes: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
